
import Vue from 'vue'
import CommandBouncer from './components/CommandBouncer.vue'

export default Vue.extend({
  name: 'App',
  components: {
    CommandBouncer
  }
})
